import React from "react";
import LegalDocument from "../../components/legal/LegalDocument";
import { useCurrency } from "../../context/CurrencyContext";

export default function RenterTermsFull() {
  const { settings } = useCurrency();
  return (
    <LegalDocument
      eyebrow="Legal"
      title="Renter Terms & Conditions"
      text={settings?.legal_renter_terms}
      loading={!settings?.legal_renter_terms}
      relatedLinks={[
        { to: "/legal/terms/host", label: "Host Terms & Conditions" },
        { to: "/legal/privacy", label: "Privacy Policy" },
      ]}
    />
  );
}
